import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {SHARED_COMPONENTS} from './components';
import {SharedIconsModule} from '../../shared-modules/shared-icons/shared-icons.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PushPipe} from '@ngrx/component';
import {AgGridAngular} from 'ag-grid-angular';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {CdkDrag, CdkDropList} from '@angular/cdk/drag-drop';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {UiComponentsModule} from '../shared-module-ui/ui-components.module';

@NgModule({
  declarations: [
    ...SHARED_COMPONENTS,
  ],
  imports: [
    AgGridAngular,
    CommonModule,
    FormsModule,
    MatTooltipModule,
    NgOptimizedImage,
    PushPipe,
    ReactiveFormsModule,
    SharedIconsModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    CdkDropList,
    CdkDrag,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule,
    UiComponentsModule,
  ],
  exports: [
    ...SHARED_COMPONENTS,
    PushPipe,
  ],
})
export class SharedComponentsModule {
}
